import { PathViewModel, StateViewModel } from '@/features/bots/models/designer';
import {
  checkStateForInvalidDecisions,
  pathContainsFlowVariable,
  removeFlowVariableFromState,
} from '@/features/bots/services/flowVariableUtils';
import { AppState } from '@/store/app';
import { ActionTree } from 'vuex';
import { FlowDesignerState } from '..';
import { DELETE_STATE } from './actionTypes';
import { REMOVE_STATE } from './mutationTypes';

export const actions: ActionTree<FlowDesignerState, AppState> = {
  [DELETE_STATE]({ commit, state }, stateToRemove: StateViewModel) {
    commit(REMOVE_STATE, stateToRemove);

    if (stateToRemove.storedVariable && stateToRemove.storedVariable.scope === 'flow') {
      deleteUnusedFlowVariable(state, stateToRemove, state.currentFlow.paths);
    }
  },
};

function deleteUnusedFlowVariable(state: FlowDesignerState, stateToRemove: StateViewModel, paths: PathViewModel[]) {
  const storedFlowVariable =
    stateToRemove.storedVariable && stateToRemove.storedVariable.scope === 'flow' ? stateToRemove.storedVariable : null;

  if (!storedFlowVariable) {
    return;
  }

  const foundVarElsewhere = state.currentFlow.paths.some((path) => {
    return pathContainsFlowVariable(path, storedFlowVariable);
  });

  if (!foundVarElsewhere) {
    removeFlowVariableFromState(state, storedFlowVariable);
    paths.forEach((path: PathViewModel) => {
      path.states.forEach((pathState: StateViewModel) => {
        checkStateForInvalidDecisions(storedFlowVariable, pathState);
      });
    });
  }
}
